import React from 'react';
import './QuoteBand.css';

export default function QuoteBand() {
  return (
    <div className="quote-band">
      <div className="quote-band-dots quote-band-dots-left" aria-hidden="true" />
      <div className="quote-band-dots quote-band-dots-right" aria-hidden="true" />
      <div className="quote-band-ring quote-band-ring-top" aria-hidden="true" />
      <div className="quote-band-ring quote-band-ring-bottom" aria-hidden="true" />
      <div className="quote-band-panel quote-band-panel-left" aria-hidden="true" />
      <div className="quote-band-panel quote-band-panel-right" aria-hidden="true" />

      <div className="quote-band-inner">
        <div className="quote-icon-row" aria-hidden="true">
          <span />
          <div className="quote-icon">
            <svg viewBox="0 0 24 24">
              <path d="M9 6V5a3 3 0 0 1 6 0v1h3.2A2.8 2.8 0 0 1 21 8.8v9.4a2.8 2.8 0 0 1-2.8 2.8H5.8A2.8 2.8 0 0 1 3 18.2V8.8A2.8 2.8 0 0 1 5.8 6H9Zm2 0h2V5a1 1 0 0 0-2 0v1Zm-6 5.15V18.2c0 .44.36.8.8.8h12.4c.44 0 .8-.36.8-.8v-7.05l-5.58 1.98V14a1 1 0 0 1-1 1h-.84a1 1 0 0 1-1-1v-.87L5 11.15Zm14-2.35a.8.8 0 0 0-.8-.8H5.8a.8.8 0 0 0-.8.8v.23l5.58 1.99V11a1 1 0 0 1 1-1h.84a1 1 0 0 1 1 1v.02L19 9.03V8.8Z" />
            </svg>
          </div>
          <span />
        </div>

        <blockquote>
          <h2>"Your Dream Career Starts Here."</h2>
          <cite>"Where Talent, Opportunity, &amp; Success Come Together."</cite>
        </blockquote>

        <div className="quote-divider" aria-hidden="true">
          <span />
          <strong />
          <span />
        </div>
      </div>
    </div>
  );
}
